import React, { useEffect, useState } from "react";
import safeLogger from "../../utils/safeLogger";
import {
  Button,
  Typography,
  Modal,
  Box,
  Divider,
  TextField,
} from "@mui/material";

const plansDetails = [
  {
    id: "basico",
    title: "Básico",
    price: "R$100,00",
    features: [
      "✔ Análise de Código",
      "✔ Criação de Testes Automatizados",
      "✔ Criação de Testes Unitários",
      "✔ Exportação de Resultados em Excel e PDF",
      "✖ Usuário admin com Exportação em massa e inativação de usuários",
    ],
    buttonLabel: "Assinar",
  },
  // {
  //   id: "otimo",
  //   title: "Ótimo",
  //   price: "R$120,00",
  //   features: [
  //     "✔ Desenvolvimento de conceito",
  //     "✔ Design de interface",
  //     "✔ Gerenciamento de configuração",
  //     "✔ Garantia de qualidade de software",
  //     "✖ Integração de aplicativos",
  //   ],
  //   buttonLabel: "Assinar",
  //   popular: true,
  // },
  // {
  //   id: "avancado",
  //   title: "Avançado",
  //   price: "R$150,00",
  //   features: [
  //     "✔ Desenvolvimento de conceito",
  //     "✔ Design de interface",
  //     "✔ Gerenciamento de configuração",
  //     "✔ Garantia de qualidade de software",
  //     "✔ Integração de aplicativos",
  //   ],
  //   buttonLabel: "Assinar",
  // },
  {
    id: "empresarial",
    title: "Empresarial",
    price: "Personalizado",
    features: [
      "✔ Análise de Código",
      "✔ Criação de Testes Automatizados",
      "✔ Criação de Testes Unitários",
      "✔ Exportação de Resultados em Excel e PDF",
      "✔ Usuário admin com Exportação em massa e inativação de usuários",
    ],
    buttonLabel: "Entre em Contato",
  },
];

const Plans = () => {
  const [paymentLinks, setPaymentLinks] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [charCount, setCharCount] = useState(500);
  const [messageStatus, setMessageStatus] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Busca os links de pagamento da API
    const fetchPaymentLinks = async () => {
      try {
        const response = await fetch(
          "https://codefort.onrender.com/api/generate_payment_links"
        );
        const data = await response.json();
        setPaymentLinks(data); // Armazena os links de pagamento no estado
      } catch (error) {
        safeLogger.error("Erro ao buscar links de pagamento:", error.message);
      }
    };

    fetchPaymentLinks();
  }, []);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };

    if (name === "name" && (value.length < 3 || value.length > 50)) {
      newErrors.name = "Nome deve ter entre 3 e 50 caracteres";
    } else {
      delete newErrors.name;
    }

    if (name === "phone") {
      const formattedPhone = formatPhoneNumber(value);
      if (!/^\(\d{2}\) \d{4,5}-\d{4}$/.test(formattedPhone)) {
        newErrors.phone = "Número inválido";
      } else {
        delete newErrors.phone;
      }
      setFormData((prev) => ({ ...prev, phone: formattedPhone }));
      return;
    }

    if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      newErrors.email = "E-mail inválido";
    } else {
      delete newErrors.email;
    }

    if (name === "message") {
      setCharCount(500 - value.length);
      if (value.length > 500) {
        newErrors.message = "Mensagem pode ter no máximo 500 caracteres";
      } else {
        delete newErrors.message;
      }
    }

    setErrors(newErrors);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(errors).length > 0) return;

    // Adiciona "type: enterprise" somente se for do plano empresarial
  const dataToSend = {
    ...formData,
    type: isModalOpen ? "enterprise" : undefined, // Se o modal estiver aberto, é do plano empresarial
  };

    try {
      const response = await fetch(
        "https://codefort.onrender.com/api/send-contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        }
      );
      if (response.ok) {
        setMessageStatus("Mensagem enviada com sucesso!");
        setTimeout(() => setMessageStatus(""), 5000);
        setFormData({ name: "", phone: "", email: "", message: "" });
        setCharCount(500);
      } else {
        setMessageStatus("Erro ao enviar a mensagem.");
      }
    } catch (error) {
      // Não logar dados sensíveis do usuário — registrar apenas erro genérico
      safeLogger.error("Erro ao enviar contato");
    }
  };

  return (
    <div id="plans" className="plans-section">
      <div className="container">
        <div className="section-title">
          <h2>Nossos Planos</h2>
          <p>Escolha o plano ideal para o seu negócio.</p>
        </div>
        <div className="plans-container">
          {plansDetails.map((plan) => (
            <div
              key={plan.id}
              className={`plan ${plan.popular ? "popular" : ""}`}
            >
              <h3 className="plan-title">{plan.title}</h3>
              <p className="plan-price">{plan.price}</p>
              <ul className="plan-features">
                {plan.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              {plan.id === "empresarial" ? (
                <Button
                  className="plan-button"
                  onClick={handleOpenModal}
                  style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                  }}
                >
                  {plan.buttonLabel}
                </Button>
              ) : (
                <Button
                  className="plan-button"
                  onClick={() => {
                    const link = paymentLinks[plan.id];
                    if (link) {
                      window.location.href = link; // Redireciona para o link correto
                    } else {
                      alert(
                        "Link de pagamento não está disponível no momento."
                      );
                    }
                  }}
                  style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                  }}
                >
                  {plan.buttonLabel}
                </Button>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Modal de contato */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Entre em Contato
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form onSubmit={handleSubmit}>
            <TextField
              label="Nome"
              name="name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              required
            />
            <TextField
              label="Telefone"
              name="phone"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
              required
            />
            <TextField
              label="E-mail"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
              required
            />
            <TextField
              label="Mensagem"
              name="message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              margin="normal"
              value={formData.message}
              onChange={handleChange}
              error={!!errors.message}
              helperText={errors.message}
              required
            />
            <Typography sx={{ mt: 1, fontSize: 12, color: "gray" }}>
              Restantes: {charCount} caracteres
            </Typography>
            {messageStatus && (
              <Typography sx={{ mt: 2, color: "green", fontWeight: "bold" }}>
                {messageStatus}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              Enviar
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default Plans;
